// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getVarinatChildrenProductInfo from "@awc/App/Handlers/VariantProducts/VariantProducts";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { addToChainAfter, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    ConfigurationType,
    GetProductByIdApiV2Parameter,
    GetProductVariantChildApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    PopulateApiParameter,
    RequestVariantChildrenFromApi,
    ValidateProduct
} from "@insite/client-framework/Store/Components/ProductSelector/Handlers/SetProduct";
import {
    hasEnoughInventory,
} from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Parameter {
    variantId?: string;
    productId?: string;
    searchTerm?: string;
    validateProduct?: boolean;
    skipInventoryValidation?: boolean;
    denyFixedConfiguration?: boolean;
    isProductSelectorVariantModal?: boolean;
}

interface Props {
    apiParameter: GetProductByIdApiV2Parameter | GetProductVariantChildApiV2Parameter;
    variantChildren?: ProductModel[] | null;
    product?: ProductModel;
    productInfo?: ProductInfo;
}

type HandlerType = Handler<Parameter, Props>;

export const XngPopulateApiParameter: HandlerType = props => {
    props.apiParameter?.expand?.push("properties");
}

export const XngLoadVarintChildrenData: HandlerType = props => {
    if (props.parameter.isProductSelectorVariantModal) {
        const children = props.variantChildren || [];
        props.dispatch(
            getVarinatChildrenProductInfo({
                products: [props.product!, ...children],
            }),
        );
    }
};

export const XngValidateProduct: HandlerType = ({ parameter, product, productInfo, getState, dispatch }) => {
    if (!parameter.validateProduct || !product || !productInfo) {
        return;
    }

    const productIsConfigurable =
        product.canConfigure ||
        (product.configurationType !== ConfigurationType.None &&
            (product.configurationType !== ConfigurationType.Fixed || parameter.denyFixedConfiguration));

    if (productIsConfigurable) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsConfigurable",
        });
    }
    /**
     * XNG-Change we need to add && product.variantTraits?.length
     * as we have some products marked as parent but do not have children
     */

    if (product.isVariantParent && product.variantTraits?.length) {
        dispatch({
            type: "Components/ProductSelector/OpenVariantModal",
            productId: product.id,
        });

        return false;
    }

    if (!parameter.skipInventoryValidation && !hasEnoughInventory(getState(), { product, productInfo })) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsUnavailable",
        });
    }

    if (!product.canAddToCart && !productIsConfigurable) {
        dispatch({
            type: "Components/ProductSelector/SetErrorType",
            errorType: "productIsUnavailable",
        });
    }
};


addToChainAfter(chain, RequestVariantChildrenFromApi, XngLoadVarintChildrenData);
addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, ValidateProduct, XngValidateProduct);